<template>
  <div class="reusable-table-container">
    <el-table :data="paginatedData" highlight-current-row border @current-change="handleCurrentRowChangeInChild" @row-click="handleRowClickInChild" style="width: 100%; font-size: 16px;">
      <el-table-column v-for="column in tableColumns" :key="column.prop" :prop="column.prop" :label="column.label" :min-width="column.minWidth" :height="column.height" :fixed="column.fixed"></el-table-column>
      <el-table-column label="操作" :width="actionsWidth" fixed="right">
        <template slot-scope="{ row, $index }">
          <el-button size="mini" type="danger" icon="el-icon-delete" @click.stop="handleDeleteConfirm($index, row)" title="删除" round plain style="font-size: 12px;">删除</el-button>
          <el-button size="mini" type="info" icon="el-icon-zoom-in" @click.stop="handleDetail($index, row)" title="详情" round plain style="font-size: 12px;">详情</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination class="pagination-right" small @current-change="handlePageChangeInChild" :current-page="currentPage" :page-size="pageSize" layout="prev, pager, next, jumper" :total="tableData.length"></el-pagination>
    <DetailDialog :visible.sync="detailDialogVisible" :row-data="selectedRowData" :table-basic-columns="tableBasicColumns" :table-behave-columns="tableBehaveColumns"  :table-light-columns="tableLightColumns" :table-outdoor-columns="tableOutdoorColumns" :table-words="tableWords" :readonly="true" @close="handleDetailDialogClose" @save="handleDetailDialogSave"/></div>
</template>

<script>
import DetailDialog from './DetailDialog.vue';

export default {
  name: 'ReusableTable',
  components: {
    DetailDialog
  },
  props: {
    name: {
      type: String,
      default: ''
    },
    tableData: {
      type: Array,
      required: true,
      default: () => []
    },
    tableColumns: {
      type: Array,
      required: true,
      default: () => []
    },
    pageSize: {
      type: Number,
      default: 5
    },
    actionsWidth: {
      type: String,
      default: '165'
    }
  },
  data() {
    return {
      currentData: [],
      currentPage: 1,
      currentRowInChild: null,
      currentDetailRow: null,
      newEntry: {},
      detailDialogVisible: false,
      selectedRowData: {},
      tableBasicColumns: [
        { prop: 'user_id', label: '用户ID', width: '160px' },
        { prop: 'store', label: '门店', width: '160px' },
        { prop: 'optometrist', label: '验光师', width: '160px' },
        { prop: 'patient_id', label: '用户UID', width: '160px' },
        { prop: 'patient_no', label: '用户编号', width: '160px' },
        { prop: 'examine_id', label: '检查ID', width: '160px' },
        { prop: 'check_date', label: '检查日期', width: '160px' },
        { prop: 'ai_first_analysis_date', label: '首次使用AI分析时间', width: '180px' },
        { prop: 'name', label: '姓名', width: '160px' },
        { prop: 'birth_date', label: '出生日期', width: '160px' },
        { prop: 'gender', label: '性别', width: '160px' },
        { prop: 'a16', label: '裸眼视力-右眼', width: '160px' },
        { prop: 'a17', label: '裸眼视力-左眼', width: '160px' },
        { prop: 'a18', label: '电脑验光-右眼', width: '160px' },
        { prop: 'a19', label: '电脑验光-左眼', width: '160px' },
        { prop: 'a20', label: '旧镜度数-右眼', width: '160px' },
        { prop: 'a21', label: '旧镜度数-左眼', width: '160px' },
        { prop: 'od_balanced_correct', label: '平衡屈光度矫正视力-右眼', width: '180px' },
        { prop: 'os_balanced_correct', label: '平衡屈光度矫正视力-左眼', width: '180px' },
        { prop: 'a2', label: '眼轴-右眼 (mm)', width: '160px' },
        { prop: 'a1', label: '眼轴-左眼 (mm)', width: '160px' },
        { prop: 'a4', label: '轴曲比-右眼', width: '160px' },
        { prop: 'a3', label: '轴曲比-左眼', width: '160px' },
        { prop: 'a6', label: '平衡屈光度-右眼 (D)', width: '160px' },
        { prop: 'a5', label: '平衡屈光度-左眼 (D)', width: '160px' },
        { prop: 'a22', label: '立体视', width: '160px' },
        { prop: 'a23', label: 'Worth 4 dot', width: '160px' },
        { prop: 'a10', label: '远距离水平隐斜', width: '160px' },
        { prop: 'a11', label: '近距离水平隐斜', width: '160px' },
        { prop: 'a12', label: '远距离水平融像BI', width: '160px' },
        { prop: 'a13', label: '远距离水平融像BO', width: '160px' },
        { prop: 'a14', label: '近距离水平融像BI', width: '160px' },
        { prop: 'a15', label: '近距离水平融像BO', width: '160px' },
        { prop: 'a7', label: '视功能AC/A', width: '160px' },
        { prop: 'a24', label: '正相对调节(PRA)', width: '160px' },
        { prop: 'a25', label: '负相对调节(NRA)', width: '160px' },
        { prop: 'a26', label: '调节反应(BCC)', width: '160px' },
        { prop: 'a8', label: '视功能调节幅度-右眼', width: '160px' },
        { prop: 'a9', label: '视功能调节幅度-左眼', width: '160px' },
        { prop: 'a27', label: '集合近点(NPC)', width: '160px' },
        { prop: 'a28', label: '调节灵敏度-双眼(OU)', width: '160px' },
        { prop: 'a29', label: '调节灵敏度-右眼(OD)', width: '160px' },
        { prop: 'a30', label: '调节灵敏度-左眼(OS)', width: '160px' },
        { prop: 'visual_function', label: '视功能检查结果评估', width: '220px' },
        { prop: 'pre_diagnose_time', label: '上次检查日期', width: '160px' },
      ],
      tableBehaveColumns: [
        { prop: 'b1', label: '最近一周，孩子平均每天的睡眠时间', width: '240px' },
        { prop: 'c1', label: '最近一周，孩子平均每天在家看书写作业的时间', width: '310px' },
        { prop: 'd1', label: '最近一周，孩子平均每天使用电子产品的时间', width: '310px' },
      ],
      tableLightColumns: [
        { prop: 'h1', label: '最近一周，孩子平均每天户外的时间', width: '240px' },
        { prop: 'h2', label: '孩子平时读写时开什么灯具', width: '180px' },
      ],
      tableOutdoorColumns: [
        { prop: 'check_date', label: '检查日期', width: '100px' },
        { prop: 'f1', label: '户外活动时长（分钟）', width: '120px' },
        { prop: 'hour_id', label: '时间段', width: '100px' },
        { prop: 'g1', label: '光照强度(lx)', width: '100px' },
      ],
      tableWords: {
        gender: ['男', '女'],
        a22: ['无', '有'],
        a23: ['2', '3', '4', '5'],
        b1: ['少于6小时', '6-7小时', '7-8小时', '8-9小时', '9-10小时', '10-11小时', '11-12小时', '12小时或以上'],
        c1: ['少于1小时', '1-2小时', '2-3小时', '3-4小时', '4-5小时', '5小时以上', '无'],
        d1: ['10分钟以内', '10-30分钟', '0.5-1小时', '1-2小时', '2-3小时', '3-4小时', '4-5小时', '5小时以上'],
        hour_id: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23],
        h1: ['30分钟以内', '30分钟-1小时', '1-2小时', '2小时以上'],
        h2: ['\u9876\u706f', '\u53f0\u706f', '\u9876\u706f+\u53f0\u706f', '\u9876\u706f+\u5927\u8def\u706f/\u5c0f\u8def\u706f', '\u5927\u8def\u706f/\u5c0f\u8def\u706f'],
      },
    };
  },
  computed: {
    paginatedData() {
      console.log('paginatedData: ', this.tableData.length);
      const start = (this.currentPage - 1) * this.pageSize;
      const end = start + this.pageSize;
      const data = JSON.parse(JSON.stringify(this.tableData.slice(start, end)));
      
      // 需要格式化为两位小数的字段
      const twoDecimalFields = ['a1', 'a2', 'a3', 'a4', 'a8', 'a9', 'a24', 'a25', 'a26'];
      // 需要格式化为一位小数的字段
      const oneDecimalFields = ['a16', 'a17', 'a27', 'a28', 'a29', 'a30', 'od_balanced_correct', 'os_balanced_correct'];
      // 需要格式化为正负号整数的字段
      const signedIntFields = ['a10', 'a11'];
      
      data.forEach((row) => {
        // 格式化两位小数字段
        twoDecimalFields.forEach(field => {
          if (row[field] !== null && row[field] !== undefined && row[field] !== '') {
            const num = parseFloat(row[field]);
            if (!isNaN(num)) {
              row[field] = num.toFixed(2);
            }
          }
        });
        
        // 格式化一位小数字段
        oneDecimalFields.forEach(field => {
          if (row[field] !== null && row[field] !== undefined && row[field] !== '') {
            const num = parseFloat(row[field]);
            if (!isNaN(num)) {
              row[field] = num.toFixed(1);
            }
          }
        });
        
        // 格式化正负号整数字段
        signedIntFields.forEach(field => {
          if (row[field] !== null && row[field] !== undefined && row[field] !== '') {
            const num = parseFloat(row[field]);
            if (!isNaN(num)) {
              const intNum = Math.round(num);
              row[field] = intNum >= 0 ? `+${intNum}` : `${intNum}`;
            }
          }
        });
        
        // 处理映射字典
        for (const key in this.tableWords) {
          if (key === 'a23') {
            continue;
          }
          if (this.tableWords[key] && Object.prototype.hasOwnProperty.call(this.tableWords[key], row[key])) {
            row[key] = this.tableWords[key][row[key]];
          }
        }
      });
      return data;
    },
  },
  methods: {
    initializeNewEntry() {
      const entry = {};
      if (this.tableColumns && this.tableColumns.length > 0) {
        this.tableColumns.forEach(column => {
          this.$set(entry, column.prop, '');
        });
      }
      this.newEntry = entry;
    },
    handlePageChangeInChild(val) {
      this.currentPage = val;
      this.$emit('page-change', val);
    },
    handleCurrentRowChangeInChild(val) {
      this.currentRowInChild = val;
      this.$emit('current-row-change', val);
    },
    handleRowClickInChild(row, column, event) {
      const paginatedIndex = this.paginatedData.indexOf(row);
      const realIndex = (this.currentPage - 1) * this.pageSize + paginatedIndex;
      this.$emit('row-click', row, realIndex, column, event);
    },
    handleDelete(index, row) {
      const actualIndex = (this.currentPage - 1) * this.pageSize + index;
      this.$emit('delete-row', actualIndex, row);
    },
    handleDeleteConfirm(index, row) {
      this.$confirm('确定要删除这条记录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.handleDelete(index, row);
        this.$message.success('删除成功');
      }).catch(() => {
        this.$message.info('已取消删除');
      });
    },
    handleAddDetail() {
      console.log('Adding new detail row');
      this.currentDetailRow = null;
      
      // 从本地存储获取用户信息
      const savedUserInfo = localStorage.getItem('userInfo');
      let defaultStore = '';
      let defaultOptometrist = '';
      
      if (savedUserInfo) {
        const userInfo = JSON.parse(savedUserInfo);
        defaultStore = userInfo.store || '';
        defaultOptometrist = userInfo.optometrist || '';
      }
      
      // 获取当前日期
      const today = new Date();
      const currentDate = today.getFullYear() + '-' + 
                         String(today.getMonth() + 1).padStart(2, '0') + '-' + 
                         String(today.getDate()).padStart(2, '0');
      
      this.selectedRowData = {
        store: defaultStore,
        optometrist: defaultOptometrist,
        check_date: currentDate,
        ai_first_analysis_date: ''
      };
      this.$set(this.selectedRowData, 'user_id', null);  // 设置user_id为null
      this.$set(this.selectedRowData, 'outdoor', []);
      this.detailDialogVisible = true;
    },
    handleDetail(index, row) {
      // eslint-disable-next-line no-unused-vars
      const unusedParams = { row };
      this.currentDetailRow = (this.currentPage - 1) * this.pageSize + index;
      const originalRow = this.tableData[this.currentDetailRow];
      this.selectedRowData = { ...originalRow };
      this.detailDialogVisible = true;
      this.$emit('detail-row', this.currentDetailRow, originalRow);
    },
    handleDetailDialogClose() {
      this.detailDialogVisible = false;
      this.selectedRowData = {};
      this.currentDetailRow = null;
    },
    handleDetailDialogSave(updatedData, callback) {
      // 发送更新请求给父组件
      this.$emit('update-row', this.currentDetailRow, updatedData, (success) => {
        // 调用DetailDialog传递的回调函数
        if (callback) {
          callback(success);
        }
        
        // 如果保存成功，关闭对话框
        if (success) {
          this.handleDetailDialogClose();
        }
      });
    }
  },
  watch: {
    tableData: {
      handler() {
        console.log('Table data updated:', this.tableData.length);
        if (this.tableData.length > 0 && (this.currentPage -1) * this.pageSize >= this.tableData.length) {
          this.currentPage = Math.ceil(this.tableData.length / this.pageSize) || 1;
        } else if (this.tableData.length === 0) {
          this.currentPage = 1;
        }
      },
      deep: true
    },
    tableColumns: {
      handler() {
        this.initializeNewEntry();
      },
      immediate: true,
      deep: true
    }
  }
};
</script>

<style scoped>
.reusable-table-container {
  width: 100%;
  display: flex;
  flex-direction: column;
}

.pagination-right {
  text-align: right;
  margin-top: 10px; 
}

::v-deep .el-table th {
  padding: 6px 0;
}

::v-deep .el-table td {
  padding: 6px 0;
}

.el-table button {
  font-size: 14px;
}

::v-deep .el-table__fixed-right {
  z-index: 10;
}

::v-deep .el-button--mini {
  padding: 5px 10px;
  font-size: 12px;
  margin: 0 2px;
}

::v-deep .el-button--mini + .el-button--mini {
  margin-left: 4px;
}

.form-fields-wrapper {
  display: flex;
  flex-wrap: wrap;
  gap: 15px 20px;
}

.form-field-item {
  display: flex;
  flex-direction: column;
  flex: 1 1 200px;
  min-width: 180px;
}

.form-field-item label {
  margin-bottom: 5px;
  font-size: 14px;
  color: #606266;
  text-align: left;
}

.form-field-item .el-input--small {
  width: 100%;
}
</style>
